// 登陆页
export const LOGIN_IN = 'LOGIN_IN';
export const GET_USER_INFO = 'GET_USER_INFO';
export const GET_SERVICE_LIST = 'GET_SERVICE_LIST';
export const GET_PROFILE_INFO = 'GET_PROFILE_INFO';
export const GET_RATE_INFO = 'GET_RATE_INFO';
